import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_authentication",
  "use": "icon-pnc_ic_authentication-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_authentication\"><path clip-rule=\"evenodd\" d=\"m6.9 19h14.1c.6 0 1-.4 1-1v-8.7c-1.6-2-4.2-3.3-7-3.3-5 0-9 4-9 9 0 1.4.3 2.8.9 4z\" fill=\"#d1f0c5\" fill-rule=\"evenodd\" /><g fill=\"#1a1a1a\"><path d=\"m21 20h-18c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2zm0-2v1zm-18-12v12h18v-12z\" /><path d=\"m9 11h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m9 15h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m14.6 15.3c-.3 0-.7-.1-.9-.4l-2-2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.5 1.5 3.7-3.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-4.2 4.2c-.2.2-.5.4-.9.4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_authentication.svg
// module id = CUL8
// module chunks = 87